import { useState } from 'react';
import { BLUE, DARK, RED } from '../constants/colors';

function fmtCurrency(v) {
  const n = String(v||'').replace(/[^\d]/g,'');
  return n ? Number(n).toLocaleString('en-US') : '';
}

export default function Field({label,type="text",value,onChange,placeholder,options,prefix,tooltip,error,currency}){
  const [focused,setFocused]=useState(false);
  const border=focused?BLUE:error?RED:"#E2E8F0";

  const handleChange = e => {
    if (!currency){ onChange(e.target.value); return; }
    onChange(e.target.value.replace(/[^\d]/g,''));
  };

  const inputType = currency ? 'text' : type;
  const inputValue = currency ? fmtCurrency(value) : value;

  return(
    <div style={{marginBottom:16}}>
      <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:5}}>
        <label style={{fontSize:11,fontWeight:700,color:"#475569",textTransform:"uppercase",letterSpacing:"0.08em",fontFamily:"sans-serif"}}>{label}</label>
        {tooltip&&<span title={tooltip} style={{width:16,height:16,borderRadius:"50%",background:"#F1F5F9",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#94a3b8",cursor:"help",fontFamily:"sans-serif",flexShrink:0}}>?</span>}
      </div>
      {options?(
        <select value={value} onChange={e=>onChange(e.target.value)} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}
          style={{width:"100%",padding:"11px 32px 11px 14px",border:`1.5px solid ${border}`,borderRadius:9,fontSize:14,color:DARK,background:`#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2394a3b8' strokeWidth='1.5' fill='none'/%3E%3C/svg%3E") no-repeat right 12px center`,outline:"none",fontFamily:"sans-serif",boxSizing:"border-box",appearance:"none",transition:"border-color 0.2s",boxShadow:focused?`0 0 0 3px ${BLUE}18`:"none"}}>
          {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ):(
        <div style={{position:"relative"}}>
          {prefix&&<span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:"#94a3b8",fontSize:14,fontFamily:"sans-serif",pointerEvents:"none"}}>{prefix}</span>}
          <input type={inputType} value={inputValue} onChange={handleChange} placeholder={placeholder}
            onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}
            style={{width:"100%",padding:"11px 14px",paddingLeft:prefix?26:14,border:`1.5px solid ${border}`,borderRadius:9,fontSize:14,color:DARK,outline:"none",fontFamily:"sans-serif",boxSizing:"border-box",transition:"border-color 0.2s, box-shadow 0.2s",boxShadow:focused?`0 0 0 3px ${BLUE}18`:"none",background:"#fff"}}/>
        </div>
      )}
      {error&&<p style={{margin:"4px 0 0",fontSize:11,color:RED,fontFamily:"sans-serif"}}>{error}</p>}
    </div>
  );
}
